'use strict'

module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/bail/index.js
// module id = 1207
// module chunks = 2